<template>
    <div class="deploy-backup-container">
        <div class="img-container">
            <img src="/static/images/backup_deploy.png" alt="backup icon">
        </div>

        <vertical-steps :steps="steps"></vertical-steps>

        <app-button v-if="showDoneButton" @click="close" type="primary">Done</app-button>
    </div>
</template>

<script>
import VerticalSteps from "../../../components/Steps/VerticalSteps";
import {STEP_STATUS_SUCCESS} from "../../../components/Steps/VerticalSteps";
import {STEP_STATUS_FAILED} from "../../../components/Steps/VerticalSteps";
import {STEP_STATUS_CURRENT} from "../../../components/Steps/VerticalSteps";

export default {
    components: {
        VerticalSteps,
    },
    props: {
        backup: {type: Number, required: true},
        regions: {type: Object, required: true},
    },
    data() {
        return {
            backupName: '',
            progress: {},
            showDoneButton: false,
            statusPollIntervalMs: 5000,
            statusPollMaxAttempts: 360,
        };
    },
    computed: {
        steps() {
            let stepsCounter = 1;
            let stepsList = [];

            for (let region in this.regions) {
                stepsList.push({
                    number: stepsCounter,
                    title: 'Deploy ' + this.regions[region].name,
                    caption: this.regions[region].url,
                    status: this.progress[stepsCounter],
                });
                stepsCounter++;
            }

            return stepsList;
        }
    },
    mounted() {
        this.runBackupDeployment();
    },
    methods: {
        async runBackupDeployment() {
            let stepsCounter = 1;
            for (let region in this.regions) {
                this.$set(this.progress, stepsCounter, STEP_STATUS_CURRENT);

                try {
                    const {data} = await axios.post(
                        this.route('library.backups.deploy', {'libraryBackup': this.backup}),
                        {region: region}
                    );

                    await this.waitForDeployFinish(region, data.batch_id);
                    this.$set(this.progress, stepsCounter, STEP_STATUS_SUCCESS);
                } catch (Error) {
                    this.$set(this.progress, stepsCounter, STEP_STATUS_FAILED);
                }

                stepsCounter++;
            }

            this.showDoneButton = true;
        },
        async waitForDeployFinish(region, batchId) {
            // Region on a pre-batching version applied the backup synchronously within the deploy request
            if (!batchId) {
                return;
            }

            for (let attempt = 0; attempt < this.statusPollMaxAttempts; attempt++) {
                await new Promise(resolve => setTimeout(resolve, this.statusPollIntervalMs));

                const {data} = await axios.get(
                    this.route('library.backups.deploy-status'),
                    {params: {region: region, batch_id: batchId}}
                );

                if (data.failed) {
                    throw new Error('Backup apply failed on ' + region);
                }

                if (data.finished) {
                    return;
                }
            }

            throw new Error('Backup apply status polling timed out on ' + region);
        },
        close(e) {
            e.preventDefault();
            e.stopPropagation();

            this.$emit('close');
        }
    }
};
</script>

<style lang="scss" scoped>
.deploy-backup-container {
    margin: 0.75rem;

    & > div.img-container {
        margin: 0.75rem;
        display: flex;
        justify-content: center;
        align-items: center;

        & > img {
            width: 100px;
        }
    }

    & > button {
        margin-top: 0.75rem;
    }
}
</style>
